/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Origin_AInputs */

const en_road_dude_faq_origin_a = /** @type {(inputs: Road_Dude_Faq_Origin_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. State Property, Private Property, and Hit the Road Dude refer to the same fishing-spot encounter. The AI trend recasts the driver and sometimes changes the location.`)
};

const zh_road_dude_faq_origin_a = /** @type {(inputs: Road_Dude_Faq_Origin_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。State Property、Private Property 和 Hit the Road Dude 都源于同一段钓鱼视频。AI 版本会换掉司机，有时也会换场景。`)
};

/**
* | output |
* | --- |
* | "Yes. State Property, Private Property, and Hit the Road Dude refer to the same fishing-spot encounter. The AI trend recasts the driver and sometimes changes ..." |
*
* @param {Road_Dude_Faq_Origin_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_origin_a = /** @type {((inputs?: Road_Dude_Faq_Origin_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Origin_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_origin_a(inputs)
	return zh_road_dude_faq_origin_a(inputs)
});
export { road_dude_faq_origin_a as "road_dude.faq.origin.a" }